import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useSEO } from '../../utils/seo';

export default function Privacy() {
  useSEO({
    title: 'Datenschutzerklärung - EarnProof',
    description: 'Datenschutzerklärung von EarnProof. Informationen zur Erhebung, Verarbeitung und Nutzung personenbezogener Daten.',
    noindex: true,
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-20">
        <div className="max-w-4xl mx-auto px-4 py-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Datenschutzerklärung</h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Verantwortlicher</h2>
              <p className="text-gray-700 mb-4">
                Verantwortlicher für die Datenverarbeitung auf dieser Website ist:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700">
                  <strong>Christopher Humpert</strong><br />
                  Gutenbergstraße 34<br />
                  46045 Oberhausen<br />
                  Telefon: 0208 77800206<br />
                  E-Mail: hello@earnproof.org
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Erhebung und Speicherung personenbezogener Daten</h2>
              <p className="text-gray-700 mb-4">
                Beim Besuch unserer Website werden automatisch Informationen allgemeiner Natur erfasst. 
                Diese Informationen (Server-Logfiles) beinhalten etwa die Art des Webbrowsers, das verwendete 
                Betriebssystem, den Domainnamen Ihres Internet-Service-Providers und ähnliches.
              </p>
              <p className="text-gray-700 mb-4">
                Diese Daten sind in keiner Weise einer bestimmten Person zuordenbar und dienen lediglich:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>der ordnungsgemäßen Bereitstellung der Inhalte unserer Website</li>
                <li>der Optimierung der Inhalte unserer Website</li>
                <li>der dauerhaften Funktionsfähigkeit unserer IT-Systeme</li>
                <li>der Strafverfolgung im Falle von Cyberangriffen</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Kontaktformular</h2>
              <p className="text-gray-700 mb-4">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem 
                Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung 
                der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
              </p>
              <p className="text-gray-700 mb-4">
                Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Newsletter</h2>
              <p className="text-gray-700 mb-4">
                Wenn Sie unseren Newsletter abonnieren, verwenden wir Ihre E-Mail-Adresse ausschließlich 
                für den Versand des Newsletters. Sie können den Newsletter jederzeit abbestellen, 
                indem Sie auf den Abmeldelink in jeder Newsletter-E-Mail klicken.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Affiliate-Links</h2>
              <p className="text-gray-700 mb-4">
                EarnProof ist unabhängig und werbefrei. Wenn Sie sich über unsere Links anmelden, 
                unterstützen Sie das Projekt – ohne Mehrkosten für Sie. In vielen Fällen erhalten 
                Sie über den Affiliate-Link sogar einen kleinen Bonus oder Startvorteil.
              </p>
              <p className="text-gray-700 mb-4">
                Wir verwenden Affiliate-Links zu verschiedenen Plattformen. Wenn Sie über diese Links 
                eine Anmeldung vornehmen, erhalten wir möglicherweise eine kleine Provision, die uns 
                dabei hilft, neue Plattformen zu testen und hier zu teilen.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Ihre Rechte</h2>
              <p className="text-gray-700 mb-4">
                Sie haben das Recht:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen</li>
                <li>Berichtigung unrichtiger oder unvollständiger Daten zu verlangen</li>
                <li>Löschung Ihrer personenbezogenen Daten zu verlangen</li>
                <li>Einschränkung der Verarbeitung Ihrer Daten zu verlangen</li>
                <li>Widerspruch gegen die Verarbeitung Ihrer Daten einzulegen</li>
                <li>Ihre Daten in einem strukturierten, gängigen Format zu erhalten</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Datensicherheit</h2>
              <p className="text-gray-700 mb-4">
                Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket Layer) 
                in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird.
              </p>
              <p className="text-gray-700 mb-4">
                Außerdem sichern wir unsere Website und sonstigen Systeme durch technische und organisatorische 
                Maßnahmen gegen Verlust, Zerstörung, Zugriff, Veränderung oder Verbreitung Ihrer Daten durch 
                unbefugte Personen.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Änderungen der Datenschutzerklärung</h2>
              <p className="text-gray-700 mb-4">
                Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen 
                rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der 
                Datenschutzerklärung umzusetzen.
              </p>
              <p className="text-gray-700 mb-4">
                Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Kontakt</h2>
              <p className="text-gray-700 mb-4">
                Fragen zu dieser Datenschutzerklärung richten Sie bitte an:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700">
                  E-Mail: hello@earnproof.org<br />
                  Telefon: 0208 77800206
                </p>
              </div>
            </section>

            <div className="text-sm text-gray-500 mt-12 pt-8 border-t border-gray-200">
              <p>Stand: {new Date().toLocaleDateString('de-DE')}</p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
